<template>
	<div class="modal-overlay" @click="cancel">
		<div class="modal-content" role="dialog" aria-modal="true" :aria-labelledby="titleId" @click.stop>
			<h3 :id="titleId" class="modal-title">{{ dialog.title }}</h3>
			<p v-for="line in dialog.lines" :key="line" class="modal-message">{{ line }}</p>
			<div class="modal-actions">
				<button class="modal-btn" type="button" :disabled="busy" @click="cancel">Cancel</button>
				<button
					class="modal-btn"
					:class="dialog.tone === 'danger' ? 'modal-btn--danger' : 'modal-btn--primary'"
					type="button"
					:disabled="busy"
					@click="$emit('confirm')"
				>
					{{ busy ? dialog.busyLabel : dialog.actionLabel }}
				</button>
			</div>
		</div>
	</div>
</template>

<script setup>
import { getCurrentInstance } from 'vue';

const props = defineProps({
	// { title, lines, actionLabel, busyLabel, tone: 'primary' | 'danger' }
	dialog: { type: Object, required: true },
	busy: { type: Boolean, default: false },
});

const emit = defineEmits(['confirm', 'cancel']);

const titleId = `company-record-dialog-${getCurrentInstance()?.uid ?? 0}`;

const cancel = () => {
	if (!props.busy) emit('cancel');
};
</script>

<style scoped>
.modal-overlay {
	position: fixed;
	inset: 0;
	z-index: 1000;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(15, 23, 42, 0.45);
}

.modal-content {
	width: min(460px, calc(100vw - 32px));
	padding: 22px;
	border-radius: 6px;
	background: var(--noc-background);
	box-shadow: 0 18px 50px rgba(15, 23, 42, 0.24);
}

.modal-title {
	margin: 0 0 8px;
}

.modal-message {
	margin: 0 0 12px;
	color: var(--text-color-secondary);
}

.modal-actions {
	display: flex;
	justify-content: flex-end;
	gap: 10px;
	margin-top: 18px;
}

.modal-btn {
	height: 36px;
	padding: 0 14px;
	border: 1px solid var(--border-color);
	border-radius: 4px;
	background: var(--noc-background);
	color: var(--text-color);
	cursor: pointer;
	touch-action: manipulation;
}

.modal-btn:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.modal-btn--primary {
	border-color: var(--noc-blue);
	background: var(--noc-blue);
	color: #fff;
}

.modal-btn--danger {
	border-color: var(--noc-red);
	background: var(--noc-red);
	color: #fff;
}
</style>
